import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import type { User } from '@angular/fire/auth';
import { NavigationService, OWNER_ROUTES } from './navigation.service';
import { UserService } from './user.service';

/** Cross-route actions triggered from the global header. */
@Injectable({ providedIn: 'root' })
export class HeaderNavService {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly navService = inject(NavigationService);

  explorePath(forAuthUser: User | null | undefined): string {
    return forAuthUser?.emailVerified ? '/app/explorar' : '/explorar';
  }

  goToExplore(forAuthUser: User | null | undefined, query?: string): void {
    const q = query?.trim();
    void this.router.navigate([this.explorePath(forAuthUser)], {
      queryParams: q ? { q } : {},
    });
  }

  async goToCreate(forAuthUser: User | null | undefined): Promise<void> {
    if (!forAuthUser) {
      void this.router.navigate(['/login'], {
        queryParams: { returnUrl: '/mis-espacios?crear=1' },
      });
      return;
    }
    try {
      await this.userService.promoteToOwner(forAuthUser.uid);
    } catch (err) {
      console.error('[HeaderNav] promoteToOwner failed:', err);
      return;
    }
    this.navService.setView('mis-espacios');
    void this.router.navigate(OWNER_ROUTES.spaces, { queryParams: { crear: '1' } });
  }

  goToAccount(): void {
    void this.router.navigate(['/ajustes']);
  }

  goToMySpaces(): void {
    void this.router.navigate(OWNER_ROUTES.spaces);
  }

  goToAdmin(): void {
    void this.router.navigate(['/admin/dashboard']);
  }
}
